module.exports = __webpack_public_path__ + "static/img/mzlbOver.77ba081.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s35/mzlbOver.png
// module id = VwFz
// module chunks = 2